/**
 * Specifies how many bullet list items to show on small before adding
 * a "View all Features" expand options.
 */
export const OVERFLOW_DETAILS_COUNT = 4;
